import API from "@/services/api";
import Authentication from "@/services/authentication";
import constants from "../../../resources/constants.json";

export default {
    methods: {
        getPreference(key) {
          return localStorage.getItem(key);
        },
        setPreference(key, val) {
          localStorage.setItem(key, val);
        },
        removePreference(key) {
          localStorage.removeItem(key);
        },
        showTownsLayer() {
          const choice = 'town';
          this.mapView = choice;
          this.setPreference(constants.DATA_VIEW_KEY, choice);
        },
        showCountiesLayer() {
          const choice = 'county';
          this.mapView = choice;
          this.setPreference(constants.DATA_VIEW_KEY, choice);
        },
        showUtilitiesLayer() {
          const choice = 'utility';
          this.mapView = choice;
          this.setPreference(constants.DATA_VIEW_KEY, choice);
        },
        stringToNumber(stringAsNumber) {
            return parseInt(stringAsNumber, 10);
        },
        checkIfUserIsAdmin() {
          this.userIsAdmin = Authentication.userIsAdmin(this.user);
        },
        calculateQuickViewTotals() {
          this.totalEventsQuickview = 0;
          this.totalCustomersQuickview = 0;

            this.utilityOutages.forEach(utilityOutage => {
                this.totalEventsQuickview += parseInt(utilityOutage.totalEvents, 10);
                this.totalCustomersQuickview += parseInt(utilityOutage.totalCustomers, 10);
            });
        },
        async getData(setCacheControlMaxAgeHeader) {
          try {
            await Promise.all([
            API.GetTownOutagesWithUtilities(null, setCacheControlMaxAgeHeader).then(data => this.townOutages = data),
            API.GetCountyOutagesWithUtilities(null, setCacheControlMaxAgeHeader).then(data => this.countyOutages = data),
            API.GetUtilityOutages(null, setCacheControlMaxAgeHeader).then(data => this.utilityOutages = data)
          ]).then(values => {
            if (!values || !values.length) {return; }
            this.calculateQuickViewTotals();
            this.calculateSeverityLevels();
            this.outageDataLoaded = true;
          });
          } catch (err) {
            console.log("Unable to fetch all data");
            console.dir(err);
          }
        },
        getCurrentUser() {
          Authentication.getCurrentUser()
          .then(user => {
            this.user = user;
            this.username = user.username;
            this.checkIfUserIsAdmin();
          })
          .catch(() => {
            this.signedIn = false;
            this.username = undefined;
          });
        },
        calculateSeverityLevels() {
          const severityLevelMedium = constants.SEVERITY_LEVEL_MEDIUM;
          const severityLevelHigh = constants.SEVERITY_LEVEL_HIGH;
    
          this.utilityOutages.forEach(utilityOutage => {
            const totalCustomers = this.stringToNumber(utilityOutage.totalCustomers);
    
            if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
              utilityOutage.severityLevelMedium = true;
            } else if (totalCustomers >= severityLevelHigh) {
              utilityOutage.severityLevelHigh = true;
            }
          });
    
          this.countyOutages.forEach(countyOutage => {
            const totalCustomers = this.stringToNumber(countyOutage.totalCustomers);
    
            if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
              countyOutage.severityLevelMedium = true;
            } else if (totalCustomers >= severityLevelHigh) {
              countyOutage.severityLevelHigh = true;
            }
          });
    
          this.townOutages.forEach(townOutage => {
            const totalCustomers = this.stringToNumber(townOutage.totalCustomers);
    
            if (totalCustomers >= severityLevelMedium && totalCustomers < severityLevelHigh) {
              townOutage.severityLevelMedium = true;
            } else if (totalCustomers >= severityLevelHigh) {
              townOutage.severityLevelHigh = true;
            }
          });
        }
    }
  };